import * as signalR from '@microsoft/signalr';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { API_HUB_BASE_URL } from 'config/env';

if (!API_HUB_BASE_URL) {
  throw new Error("REACT_APP_API_HUB_BASE_URL is not defined");
}

const baseHubUri: string = API_HUB_BASE_URL;

class SignalRService {
  public hubConnection: signalR.HubConnection | null = null;
  private dispatch: ThunkDispatch<any, any, AnyAction>;

  constructor(dispatch: ThunkDispatch<any, any, AnyAction>) {
    this.dispatch = dispatch;
  }

  public startConnection = async () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(baseHubUri, {
        accessTokenFactory: async () => {
          const rememberMe = JSON.parse(localStorage.getItem('rememberMe') as string);
          const accessToken = rememberMe
            ? localStorage.getItem('AuthTokenApp')
            : sessionStorage.getItem('AuthTokenApp');
          return accessToken || '';
        },
        transport: process.env.NODE_ENV === 'development' // Delete this 3 lines after fixing WebSocket/HTTP2 noise in dev environment
          ? signalR.HttpTransportType.LongPolling   // avoids WebSocket/HTTP2 noise in dev
          : undefined,                              // prod: let SignalR negotiate + fall back
      })
      .configureLogging(signalR.LogLevel.Warning)
      .withAutomaticReconnect()
      .build();

    this.hubConnection.serverTimeoutInMilliseconds = 60000;

    // Just the badge number. The feed itself is paged over HTTP when the user opens the bell -
    // the hub used to push every notification the account had ever received on each connect.
    this.hubConnection.on('ReceiveUnseenCount', (unseenCount: number) => {
      this.dispatch({ type: 'SignalR/ReceiveUnseenCount', payload: unseenCount });
    });

    this.hubConnection.on('ReceiveNewNotification', (notification: any) => {
      this.dispatch({ type: 'SignalR/ReceiveNewNotification', payload: notification });
    });

    await this.hubConnection.start().then(() => console.log('connected')).catch(err => console.log(err));
  };

  public stopConnection = async () => {
    if (this.hubConnection) {
      // Stop the SignalR connection
      await this.hubConnection.stop();
      console.log('SignalR connection stopped.');
    }
  };
}

export default SignalRService;